{
  "io_plus_signup": true,
  "feed-mode": false,
  "dashboard-sharing": false,
  "devices": "devices",
  "blockly_legacy_actions": true,
  "blockly_actions": "blockly_actions"
}
